export enum PipelineActionEntity {
    Opportunity = 'Opportunity',
    OpportunityItem = 'OpportunityItem',
}
